import {forwardRef, ForwardRefRenderFunction} from 'react'

interface IDynamicComponent extends React.HTMLAttributes<HTMLDivElement> {
	tag: React.ElementType
}

const DynamicComponent: ForwardRefRenderFunction<HTMLDivElement, IDynamicComponent> = (
	{tag = 'div', children, className, ...attrs},
	ref,
) => {
	const Component = tag
	return (
		<Component ref={ref} {...attrs} className={className}>
			{children}
		</Component>
	)
}

export default forwardRef(DynamicComponent)
